<!-- @todo translate -->
<h1 mat-dialog-title>{{ data.item ? 'common.words.viewEdit' : 'common.words.addNewItem' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <div class="row" *ngIf="data.item">
    <div class="col-12 col-sm-6 col-md-3">
      <qrcode [qrdata]="qrcodeData" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="url"></qrcode>
    </div> <!-- /.col -->
    <div class="col-12 col-sm-6 col-md-9">
      <h5>Come usare il QR Code</h5>
      <ul>
        <li>Apri l'app Archedi e inquadra l'immagine qui accanto</li>
        <li>Segui le istruzioni che troverai sullo schermo del telefono</li>
      </ul>
    </div> <!-- /.col -->
  </div> <!-- /.row -->

  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <div class="col-12" *ngFor="let item of existingNotes">
          <div class="note-preview-box">
            <div class="text">{{ item.text }}</div>
            <div class="created-at" title="{{ item.createdAt }}">{{ item.createdAt | date }}</div>
            <div class="created-by">{{ 'common.words.createdBy' | translate }}:
              <mat-icon fontSet="fal" fontIcon="fa-user" data-id="{{ item.createdBy }}"></mat-icon>
            </div>
          </div>
        </div> <!-- /.col -->
      </div> <!-- ./row -->
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100">
    <div class="col-12 col-md-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
    <div class="col-12 col-md-6 text-right">
      <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions" class="btn-elevate">
      </mat-spinner-button>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>